import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getOpenObligationList} from '../../services/getOpenObligationList';

export const useGetOpenObligationListQuery = (enabled = true) =>
	useQuery({
		queryKey: [QUERY_KEYS.OPEN_BILLS],
		queryFn: async ({signal}) => getOpenObligationList({signal}),
		enabled,
		retry: 2,
	});
